<template>
    <slot>
        <div class="row">
          <div class="col-12 col-md-6" v-if="!isPosInvoice">
            <label for="colFormLabel" class="col-form-label">VDS Account</label>
            <v-select
                v-model="formData.vat_challan_account_head_id"
                placeholder="Select VAT Challan Receivable"
                class="w-100"
                :options="vatChallanHeads"
                label="name"
                :reduce="(name) => name.id"
            />
          </div>
          <div class="col-12 col-md-6" v-if="!isPosInvoice">
            <label for="colFormLabel" class="col-form-label">VDS Amount</label>
            <vField
                v-model="formData.vat_challan_amount"
                name="amount"
                type="number"
                class="form-control text-right"
                @keyup="validateTDSVDSAmount"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6" v-if="!isPosInvoice">
            <label for="colFormLabel" class="col-form-label">AIT Accounts</label>
            <v-select
                v-model="formData.ait_challan_account_head_id"
                placeholder="Select AIT Challan Receivable"
                class="w-100"
                :options="aitChallanHeads"
                label="name"
                :reduce="(name) => name.id"
            />
          </div>
          <div class="col-12 col-md-6" v-if="!isPosInvoice">
            <label for="colFormLabel" class="col-form-label">AIT Amount</label>
            <vField
                v-model="formData.ait_challan_amount"
                name="amount"
                type="number"
                class="form-control text-right"
                @keyup="validateTDSVDSAmount"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6" v-if="!isPosInvoice">
            <label for="colFormLabel" class="col-form-label">Discount Account</label>
            <v-select
                v-model="formData.discount_account_head_id"
                placeholder="Select Discount Account"
                class="w-100"
                :options="discountAccountHeads"
                label="name"
                :reduce="(name) => name.id"
            />
          </div>
          <div class="col-12 col-md-6" v-if="!isPosInvoice">
            <label for="colFormLabel" class="col-form-label">Discount Amount</label>
            <vField
                v-model="formData.discount_amount"
                name="amount"
                type="number"
                class="form-control text-right"
                @keyup="validateTDSVDSAmount"
            />
          </div>
        </div>

        <div class="row mb-1">
            <div class="col-12 col-md-6">
                <vField
                    v-model="props.grandTotal"
                    name="total"
                    type="number"
                    v-if="false"
                    class="form-control text-right"
                    disabled="disabled"
                />
                <label for="colFormLabel" class="col-form-label">Mode Of Payment</label>
                <v-select
                    placeholder="Select Cash & Bank Account"
                    class="w-100"
                    v-model="formData.mop_account_head_id"
                    name="mop_account_head_id"
                    :options="cashAndBank"
                    label="name"
                    :reduce="name => name.id"
                />
            </div>
            <div class="col-12 col-md-6 mb-1">
              <label for="colFormLabel" class="col-form-label">Paid Amount</label>
                <vField
                    v-model="formData.payment"
                    name="amount"
                    type="number"
                    class="form-control text-right"
                    @keyup="validatePaymentAmount"
                />
            </div>
        </div>
      <div class="row mb-1">
        <div class="col-12 col-sm-6">
            <label class="form-label" for="mopReference">MoP Reference</label>
            <vField
                v-model="formData.receipt_reference"
                name="receipt_reference"
                type="text"
                class="form-control"
            />
          </div>
      </div>
        <div class="row mb-1" v-if="false">
            <div class="col-12 col-md-6">
                <label class="form-label" for="receivedAmount">Total Collection</label>
                <vField
                    v-model="receivedAmount"
                    name="receivedAmount"
                    type="number"
                    class="form-control text-right"

                />
            </div>
            <div class="col-12 col-md-6 d-flex align-items-end">
                <h4>Change Amount: <b>{{ changeAmount }} BDT</b></h4>
            </div>
        </div>
    </slot>
</template>

<script setup>
import {computed, inject, onMounted, ref, watch, watchEffect} from "vue";
import {useRoute} from "vue-router";
import handleReceipt from "@/services/modules/receipt";
import handlePurchase from "@/services/modules/purchase";

const $router = useRoute();
const {fetchCashAndBank} = handleReceipt();
const { getAccountHeadBySlag } = handlePurchase()
const formData = inject('formData')
const showError = inject('showError')
const props = defineProps({
    grandTotal: {
        type: Number
    },
    isHospitalInvoice: {
        type: Boolean,
        default: false
    },
    isPosInvoice:{
      type:Boolean,
      default:false
    }
})

const companyId = $router.params.companyId;
const cashAndBank = ref([])
const receivedAmount = ref(null)
const vatChallanHeads = ref([]);
const aitChallanHeads = ref([]);
const discountAccountHeads = ref([]);

const setInitialValue = (array, field) => {
    if(!array.length) return;
    formData.value[field] = array[0].id
}

watchEffect(() => {
    formData.value.payment = '';
    if(!props.grandTotal || !props.isHospitalInvoice) return;
    formData.value.payment = props.grandTotal;
});

const totalAmount = computed(() => props.grandTotal)

const validatePaymentAmount = (event) => {
    const amount = event.target.value
    if (amount < 0) {
        showError("Payment Amount cannot be less than 0")
    }

    let amountValue = parseFloat(amount)
    let totalAmountValue = parseFloat(totalAmount.value)

    if (amountValue > totalAmountValue) {
      formData.value.payment = totalAmountValue
    }
}

const validateTDSVDSAmount = (event) => {
  const amount = event.target.value
  if (amount < 0) {
    showError("Payment Amount cannot be less than 0")
  }

  let ait = parseFloat(formData.value.ait_challan_amount) || 0;
  let vat = parseFloat(formData.value.vat_challan_amount) || 0;
  let discount = parseFloat(formData.value.discount_amount) || 0;
  const totalDeductions = ait + vat + discount;

  formData.value.payment = totalAmount.value - totalDeductions;
}

const changeAmount = computed(() => {
    if (formData.value.payment > 0 && receivedAmount.value && receivedAmount.value > 0) {
        return receivedAmount.value - formData.value.payment;
    }
    return 0
})

const generateMoneyReceiptNumber = async () => {
    setInitialValue(cashAndBank.value, 'mop_account_head_id');
    receivedAmount.value = null;
}

onMounted(() => {
  const companyQuery = `?company_id=${companyId}`;

  const vatChallanHeadsRes = getAccountHeadBySlag("vat_challan", companyQuery)
  const aitChallanHeadsRes = getAccountHeadBySlag("ait_challan", companyQuery)
  const discountAccountHeadsRes = getAccountHeadBySlag("discount_account", companyQuery)
    Promise.all([
        fetchCashAndBank(companyId).then(res => {
            if (res.data) cashAndBank.value = res.data
        }),
        vatChallanHeadsRes.then(({data}) => {
          if (data) vatChallanHeads.value = data
          if (data.length < 1) {
            return formData.value.vat_challan_account_head_id = null;
          }
          formData.value.vat_challan_account_head_id = data[0].id
        }),
        aitChallanHeadsRes.then(({data}) => {
          if (data) aitChallanHeads.value = data
          if (data.length < 1) {
            return formData.value.ait_challan_account_head_id = null;
          }

          formData.value.ait_challan_account_head_id = data[0].id
        }),
        discountAccountHeadsRes.then(({data}) => {
          if (data) discountAccountHeads.value = data
          if (data.length < 1) {
            return formData.value.discount_account_head_id = null;
          }

          formData.value.discount_account_head_id = data[0].id
        }),
        generateMoneyReceiptNumber(),
    ]).then(() => {
        setInitialValue(cashAndBank.value, 'mop_account_head_id');
    })
    .catch(e => {})
})

defineExpose({generateMoneyReceiptNumber})
</script>
